var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLInput",
    _vm._g(
      _vm._b(
        {
          directives: [
            {
              name: "fusioninputcheck",
              rawName: "v-fusioninputcheck",
              value: _vm.checkerObject,
              expression: "checkerObject",
            },
          ],
          model: {
            value: _vm.proxyValue,
            callback: function ($$v) {
              _vm.proxyValue = $$v
            },
            expression: "proxyValue",
          },
        },
        "HKLInput",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }